import React from "react";
import {
  Container,
  Typography,
  Card,
  CardContent,
  CardActions,
  Button,
  Grid,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import cardData from "../data/cardData";

const BackgroundContainer = styled("div")({
  position: "relative",
  width: "100%",
  height: "400px",
  backgroundImage: `url(${require("../assets/images/background_first.png")})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "white",
  textAlign: "center",
});

const HighlightedText = styled("span")({
  color: "#4D8F55",
  fontWeight: "bold",
});

const OverlayText = styled(Typography)({
  position: "relative",
  zIndex: 1,
  maxWidth: "60%",
  fontSize: "24px",
  fontWeight: "bold",
});

const CustomCard = styled(Card)({
  padding: "20px",
  borderRadius: "10px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
});

const CardContentStyled = styled(CardContent)({
  flexGrow: 1,
});

const CardIcon = styled("img")({
  height: "40px",
  margin: "10px 0",
});

const CenteredContainer = styled(Container)({
  textAlign: "center",
  maxWidth: "800px",
  margin: "0 auto",
});

const Home = () => {
  const navigate = useNavigate();

  const handleNavigate = (index) => {
    navigate("/services", { state: { selectedIndex: index } });
  };

  return (
    <>
      {/* Aici poti sa schimbi textul de pe containerul central */}
      <BackgroundContainer>
        <OverlayText variant="h4">
          <HighlightedText>Data Cert SRL</HighlightedText> este o companie
          românească specializată în consultanță privind prelucrarea datelor cu
          caracter personal și securitatea informației.
        </OverlayText>
      </BackgroundContainer>

      {/* Aici poti sa schimbi textul de sub containerul central */}
      <CenteredContainer sx={{ py: 4 }}>
        <Typography variant="h4" gutterBottom color="#4D8F55">
          Serviciile Noastre
        </Typography>
        <Typography variant="body1" gutterBottom>
          <span style={{ color: "#4D8F55" }}>Data Cert SRL</span> este o
          companie românească specializată în consultanță IT, securitatea
          informațiilor și prelucrarea datelor cu caracter personal.
        </Typography>
      </CenteredContainer>

      {/* Cards */}
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Grid container spacing={4} justifyContent="center">
          {cardData.map((card, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <CustomCard>
                <CardContentStyled>
                  <Typography variant="h5" gutterBottom color="#4D8F55">
                    {card.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {card.text}
                  </Typography>
                </CardContentStyled>
                <CardActions
                  sx={{ justifyContent: "space-between", alignItems: "center" }}
                >
                  <CardIcon src={card.icon} alt="icon" />
                  <Button
                    variant="contained"
                    onClick={() => handleNavigate(index)}
                    sx={{
                      backgroundColor: "#4D8F55",
                      color: "#fff",
                      "&:hover": {
                        backgroundColor: "#3E7A47",
                      },
                    }}
                  >
                    Citeste mai mult
                  </Button>
                </CardActions>
              </CustomCard>
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
};

export default Home;